import { arrayMoveImmutable } from "array-move";
import React, { useContext, useEffect, useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import styles from "./conditions.module.css";

import FlowContext from "../../../../contexts/flowContext";

const SortableCondition = SortableElement(({ condition }) => (
  <span className={styles.list_element}>{condition.label}</span>
));

const SortableList = SortableContainer(({ conditions }) => {
  return (
    <div className={styles.list}>
      {conditions.map((condition, index) => (
        <SortableCondition key={index} index={index} condition={condition} />
      ))}
    </div>
  );
});

const NextNodeConditions = ({ id }) => {
  const [flowState, flowDispatcher] = useContext(FlowContext);

  const [conditions, setConditions] = useState([]);
  const [node, setNode] = useState(null);

  useEffect(() => {
    const selectedNode = flowState.nodes.filter((node) => node.id === id)[0];
    setNode(selectedNode);
  }, [id]);

  useEffect(() => {
    if (
      node &&
      JSON.stringify(conditions.map((condition) => condition.id)) !==
        JSON.stringify(node.nextNodeListConditions)
    ) {
      let edges = [];

      node.nextNodeListConditions.forEach((edgeId) => {
        edges.push(flowState.edges.filter((edge) => edge.id === edgeId)[0]);
      });
      setConditions(edges);
    }
  }, [node]);

  useEffect(() => {
    if (conditions.length) {
      flowDispatcher({
        type: "order-next-node-list-conditions",
        list: conditions.map((condition) => condition.id),
        nodeId: node.id,
      });
    }
  }, [conditions]);

  const onSortEnd = function ({ oldIndex, newIndex }) {
    setConditions(arrayMoveImmutable(conditions, oldIndex, newIndex));
  };

  return <SortableList conditions={conditions} onSortEnd={onSortEnd} />;
};

export default NextNodeConditions;
